@if (canViewPage) {
  <div class="profile-container">
    @if (!isEditing) {
      <div class="row">
        <div class="col-sm-12 col-md-8 offset-md-2">
          <div class="company-profile">
            <div class="row company-profile__header align-items-center">
              <div class="col-sm-8">
                <div class="title fs-block">
                  {{company?.name}}
                </div>
              </div>
              <div class="col-sm-4 d-flex justify-content-end gap-2 align-items-center">
                <app-transfer-borrower-button
                  [company]="company"
                  [userEntitlement]="pageViewMode"
                  [hasDocuments]="hasDocuments"
                  [documentsProcessing]="documentsProcessing"
                ></app-transfer-borrower-button>
                @if (canEditPage) {
                  <button class="btn btn-outline-secondary" (click)="toggleEditing()">Edit</button>
                }
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="cham-panel">
              <div class="cham-panel__header">
                Borrower Management
              </div>
              <div class="cham-panel__content">
                <div class="row">
                  <div class="col-8">
                    <i class="fas fa-suitcase"></i><span class="text"> Portfolio:</span>
                    <span>{{company?.portfolio?.name || 'Unassigned'}}</span>
                  </div>
                </div>
                @if (showLinkedEntitiesFlag) {
                  <div class="row">
                    <div class="col-12">
                      <i class="fas fa-link"></i><span class="text"> Related Entities:</span>
                      <span>{{ linkedEntitiesStringDisplay || 'Not Linked'}}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="cham-panel">
              <div class="cham-panel__header">
                Contact Information
              </div>
              <div class="cham-panel__content">
                <div class="row">
                  <div class="col-8">
                    <i class="fas fa-user"></i><span class="text">{{company?.contactPerson}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <i class="fas fa-envelope"></i><span class="text fs-block">{{company?.email}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <i class="fas fa-phone"></i><span class="text fs-block">{{company?.contactPhone}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="cham-panel">
              <div class="cham-panel__header">
                Settings
              </div>
              <div class="cham-panel__content">
                <div class="row">
                  <div class="col-3 title">
                    Currency:
                  </div>
                  <div class="col-6 text">
                    {{currencyDisplayName}}
                  </div>
                </div>
              </div>
            </div>
            <div class="cham-panel">
              <div class="cham-panel__header">
                General Information
              </div>
              <div class="cham-panel__content">
                @if (showSicIndustry) {
                  <div
                    class="row">
                    <div class="col-3 title">
                      SIC Industry
                    </div>
                    <div class="col-6 text fs-block">
                      {{company?.sicIndustry}}
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col-3 title">
                    SIC
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.sicCode ? company?.sicCode + ' - ' + company?.sicName : ''}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    NAICS
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.naicsCode ? company?.naicsCode + ' - ' + company?.naicsName : ''}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    Type of Business
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.businessType}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    Company Size
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.size}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    Web Site
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.webSite}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    Address
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.address}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    {{customerIdLabel}}
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.externalId}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    Country
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.country}} {{company?.country && company?.countryName ? "-" : ""}} {{company?.countryName}}
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 title">
                    Region
                  </div>
                  <div class="col-6 text fs-block">
                    {{company?.region}}
                  </div>
                </div>
                @for (customAttrDefinition of customAttrDefinitions; track customAttrDefinition) {
                  <div class="row">
                    @if (customAttributesValues[customAttrDefinition.key]) {
                      <div class="col-3 title">
                        {{customAttrDefinition.name}}
                      </div>
                      <div class="col-6 text fs-block">
                        {{customAttributesValues[customAttrDefinition.key].value}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="cham-panel">
              <div class="cham-panel__header">
                Fiscal Year End @if (canEditFYEDate) {
                <button class="btn btn-sm btn-light float-end" (click)="addFiscalYearEndChange()">Add Fiscal Year End Change <i class="fas fa-plus"></i></button>
              }
            </div>
            <div class="cham-panel__content">
              @for (fye of fiscalYearEndChanges; track fye) {
                <div class="row fye-row">
                  <div class="col-12">
                    <i class="fas fa-calendar-alt"></i> {{"&nbsp;&nbsp;"}} {{fye.fiscalYearEndChange}} <button class="btn btn-sm btn-light delete-fye float-end" (click)="deleteFiscalYearEndChange(fye, $event)">Delete <i class="fas fa-times"></i></button>
                  </div>
                </div>
              }
            </div>
          </div>
          @if (showAccountingIntegrations) {
            <div class="cham-panel">
              <div class="cham-panel__header">
                Accounting Integrations @if (canEditPage) {
                <button class="btn btn-sm btn-light float-end" (click)="addAccountingIntegration()">Add Integration <i class="fas fa-plus"></i></button>
              }
            </div>
            <div class="cham-panel__content">
              @for (integrationVendor of company?.accountingIntegrations; track integrationVendor) {
                <div class="row">
                  <div class="col-6" style="text-align: center;">
                    <app-accounting-integration-logo [vendor]="integrationVendor"></app-accounting-integration-logo>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (isEditing) {
  <div class="row">
    <div class="col-8 offset-2">
      <div class="company-profile">
        <form class="form-horizontal" [formGroup]="companyForm"
          (submit)="save(companyForm.value, companyForm.valid)">
          <div class="company-profile__header">
            <div class="mb-3 row">
              <div class="col-6">
                <input [ngClass]="{'is-invalid': isFieldInvalid('name')}" class="form-control fs-block" formControlName="name" type="text">
                @if ((companyForm.get('name').hasError('required') || companyForm.get('name').hasError('nospace'))
                  && isFieldInvalid('name')) {
                  <span class="invalid-feedback"
                    >
                    Name is required
                  </span>
                }
                @if (companyForm.get('name').hasError('extraspace') && isFieldInvalid('name')) {
                  <span class="invalid-feedback"
                    >
                    No extra whitespaces are allowed
                  </span>
                }
                @if (isFieldInvalid('name') && companyForm.get('name').hasError('maxlength')) {
                  <span class="invalid-feedback"
                    >
                    Maximum of 150 characters
                  </span>
                }
              </div>
              <div class="col-6">
                <div class="float-end">
                  <button class="btn btn-link" type="reset" (click)="toggleEditing(true)">Cancel</button>
                  <button class="btn btn-primary" type="submit" [disabled]="submitted">Update</button>
                </div>
              </div>
            </div>
          </div>
          <div class="cham-panel">
            <div class="cham-panel__header">
              Borrower Management
            </div>
            <div class="cham-panel__content">
              <div class="mb-3">
                <div class="col-6">
                  <div class="input-group">
                    <span class="input-group-text ms-0"><i class="fas fa-suitcase"></i></span>
                    <select class="form-select" formControlName="portfolio">
                      <option [value]="0">Unassigned</option>
                      <option disabled>&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;&#9472;</option>
                      @for (portfolio of portfoliosArr; track portfolio) {
                        <option [value]="portfolio.id">
                          {{portfolio.name}}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              @if (showLinkedEntitiesFlag) {
                <div class="mb-3">
                  <div class="col-6">
                    <div class="input-group">
                      <span class="input-group-text ms-0"><i class="fas fa-link"></i></span>
                      <select class="form-select"
                        (change)="changeIfHaveLinkedEntities($event.target.value)">
                        <option [selected]="linkedEntities.length == 0" [value]="0">Not Linked</option>
                        <option [selected]="linkedEntities.length > 0" [value]="1">Linked to Related Entities</option>
                      </select>
                    </div>
                  </div>
                </div>
              }
              @if (areLinkedEntitiesShown) {
                <div class="mb-3">
                  @if (linkedEntities.length > 0) {
                    <ng-container class="mb-3">
                      @for (linkedEntity of linkedEntities; track linkedEntity; let i = $index) {
                        <div class="linked-entity-row">
                          <div>
                            Entity:
                          </div>
                          <div class="row-main-content">
                            {{linkedEntity.name}}
                          </div>
                          <div class="cancel-icon-container">
                            <div class="chart-close" (click)="removeLinkedEntity(linkedEntity.uuid)">
                              <i class="fas fa-times clickable"></i>
                            </div>
                          </div>
                        </div>
                      }
                    </ng-container>
                  }
                  @if (showNewRelatedEntitySearch) {
                    <div class="linked-entity-row">
                      <div class="autocomplete-row-spacers">
                        Entity:
                      </div>
                      <div class="row-main-content">
                        <app-dynamic-search
                          (whenSelected)="chooseLinkedEntity($event)"
                          [searchResultsFilter]="borrowerSearchResultsFilter"
                        ></app-dynamic-search>
                      </div>
                      <div class="cancel-icon-container">
                        <div class="chart-close autocomplete-row-spacers" (click)="hideNewRelatedEntitySearchAction()">
                          <i class="fas fa-times clickable"></i>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                @if (!showNewRelatedEntitySearch) {
                  <div class="mb-3">
                    <div class="col-4 offset-1">
                      <button class="btn btn-link" type="reset" (click)="showNewRelatedEntitySearchAction()">Add Related Entity</button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
          <div class="cham-panel">
            <div class="cham-panel__header">
              Contact Information
            </div>
            <div class="cham-panel__content">
              <div class="mb-3">
                <div class="col-6">
                  <div class="input-group">
                    <span class="input-group-text ms-0"><i class="fas fa-user"></i></span>
                    <input class="form-control fs-block" type="text" formControlName="contactPerson" [ngClass]="{'is-invalid': isFieldInvalid('contactPerson')}">
                    @if (isFieldInvalid('contactPerson') && companyForm.get('contactPerson').hasError('maxlength')) {
                      <span class="invalid-feedback"
                        >
                        Maximum of 100 characters
                      </span>
                    }
                    @if (isFieldInvalid('contactPerson') && companyForm.get('contactPerson').hasError('pattern')) {
                      <span class="invalid-feedback"
                        >
                        Name contains incorrect characters
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="col-6">
                  <div class="input-group">
                    <span class="input-group-text ms-0"><i class="fas fa-envelope"></i></span>
                    <input [ngClass]="{'is-invalid': isFieldInvalid('email')}" class="form-control fs-block" type="text" formControlName="email">
                    @if (isFieldInvalid('email') && companyForm.get('email').hasError('maxlength')) {
                      <span class="invalid-feedback"
                        >
                        Maximum of 100 characters
                      </span>
                    }
                    @if (isFieldInvalid('email') && companyForm.get('email').hasError('pattern')) {
                      <span class="invalid-feedback"
                        >
                        Email is not valid
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="col-6">
                  <div class="input-group">
                    <span class="input-group-text ms-0"><i class="fas fa-phone"></i></span>
                    <input [ngClass]="{'is-invalid': isFieldInvalid('contactPhone')}" class="form-control fs-block" type="text" formControlName="contactPhone"
                      [mask]="phoneMask">
                    @if (isFieldInvalid('contactPhone') && companyForm.get('contactPhone').hasError('maxlength')) {
                      <span class="invalid-feedback"
                        >
                        Maximum of 100 characters
                      </span>
                    }
                    @if (isFieldInvalid('contactPhone') && companyForm.get('contactPhone').hasError('pattern')) {
                      <span class="invalid-feedback"
                        >
                        Contact Phone is incorrect
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cham-panel">
            <div class="cham-panel__header">
              Settings
            </div>
            <div class="cham-panel__content" formGroupName="settings">
              <div class="mb-3">
                <div class="col-6">
                  <label>Set Currency</label>
                  <div class="input-group">
                    <select class="form-select" formControlName="currency">
                      @for (currency of supportedCurrencies; track currency) {
                        <option [value]="currency.key">
                          {{currency.key}} ({{currency.symbol}})
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cham-panel">
            <div class="cham-panel__header">
              General Information
            </div>
            <div class="cham-panel__content">
              @if (showSicIndustry) {
                <div
                  class="mb-3 row col-12">
                  <label for="sicIndustry" class="col-sm-3 control-label">SIC Industry</label>
                  <div class="col-sm-6">
                    <select class="form-select"
                      id="sicIndustry"
                      formControlName="sicIndustry"
                      [ngClass]="{'is-invalid': isFieldInvalid('sicCode')}">
                      @for (sicIndustry of sicIndustries | enumToArray; track sicIndustry; let i = $index) {
                        <option
                          [ngValue]="sicIndustry"
                        >{{borrowerService.displayFriendlyName(sicIndustry)}}</option>
                      }
                    </select>
                  </div>
                </div>
              }
              <div class="mb-3 row col-12">
                <label for="sic-code" class="col-sm-3 control-label">SIC</label>
                <div class="col-sm-6">
                  <input list="id-sic-code" id="sic-code" class="form-control"
                    formControlName="sicCode" placeholder="Enter code or title"
                    [ngClass]="{'is-invalid': isFieldInvalid('sicCode')}"
                    >
                  <datalist id="id-sic-code">
                    @for (eachSic of sicArr; track eachSic) {
                      <option [value]="eachSic.code">{{eachSic.title}} - {{eachSic.code}}</option>
                    }
                  </datalist>
                  @if (isFieldInvalid('sicCode') && companyForm.get('sicCode').hasError('maxlength')) {
                    <span class="invalid-feedback"
                      >
                      Max length 4
                    </span>
                  }
                  @if (isFieldInvalid('sicCode') && companyForm.get('sicCode').hasError('pattern')) {
                    <span class="invalid-feedback"
                      >
                      SIC contains incorrect characters
                    </span>
                  }
                </div>
              </div>
              <div class="mb-3 row col-12">
                <label for="naics" class="col-sm-3 control-label">NAICS</label>
                <div class="col-sm-6">
                  <input list="id-naics-code" id="naics" class="form-control"
                    formControlName="naicsCode" placeholder="Enter code or title"
                    [ngClass]="{'is-invalid': isFieldInvalid('naicsCode')}"
                    >
                  <datalist id="id-naics-code">
                    @for (eachNaics of naicsArr; track eachNaics) {
                      <option [value]="eachNaics['NAICS']">{{eachNaics['NAICS Title']}} - {{eachNaics['NAICS']}}</option>
                    }
                  </datalist>
                  @if (isFieldInvalid('naicsCode') && companyForm.get('naicsCode').hasError('maxlength')) {
                    <span class="invalid-feedback"
                      >
                      Max length 6
                    </span>
                  }
                  @if (isFieldInvalid('naicsCode') && companyForm.get('naicsCode').hasError('pattern')) {
                    <span class="invalid-feedback"
                      >
                      NAICS contains incorrect characters
                    </span>
                  }
                </div>
              </div>
              <div class="mb-3 row col-12">
                <label for="businessType" class="col-sm-3 control-label">Type of Business</label>
                <div class="col-sm-6">
                  <input id="businessType" class="form-control fs-block" formControlName="businessType"
                    type="text" [ngClass]="{'is-invalid': isFieldInvalid('businessType')}">
                  @if (isFieldInvalid('businessType') && companyForm.get('businessType').hasError('maxlength')) {
                    <span class="invalid-feedback"
                      >
                      Maximum of 100 characters
                    </span>
                  }
                  @if (isFieldInvalid('businessType') && companyForm.get('businessType').hasError('pattern')) {
                    <span class="invalid-feedback"
                      >
                      Type of Business contains incorrect characters
                    </span>
                  }
                </div>
              </div>
              <div class="mb-3 row col-12">
                <label for="size" class="col-sm-3 control-label">Company Size</label>
                <div class="col-sm-6">
                  <input [ngClass]="{'is-invalid': isFieldInvalid('size')}" id="size" class="form-control fs-block" formControlName="size" type="text">
                  @if (isFieldInvalid('size') && (companyForm.get('size').hasError('min') ||
                    companyForm.get('size').hasError('max'))) {
                    <span class="invalid-feedback"
                      >
                      It must be a number, between 1 and 10000
                    </span>
                  }
                  @if (isFieldInvalid('size') && companyForm.get('size').hasError('isInteger')) {
                    <span class="invalid-feedback"
                      >
                      It must be an integer
                    </span>
                  }
                </div>
              </div>
              <div class="mb-3 row col-12">
                <label for="webSite" class="col-sm-3 control-label">Web Site</label>
                <div class="col-sm-6">
                  <input [ngClass]="{'is-invalid': isFieldInvalid('webSite')}" id="webSite" class="form-control fs-block" formControlName="webSite" type="text">
                  @if (isFieldInvalid('webSite') && companyForm.get('webSite').hasError('maxlength')) {
                    <span class="invalid-feedback"
                      >
                      Maximum of 100 characters
                    </span>
                  }
                  @if (isFieldInvalid('webSite') && companyForm.get('webSite').hasError('pattern')) {
                    <span class="invalid-feedback"
                      >
                      Url is not valid
                    </span>
                  }
                </div>
              </div>
              <!-- edit customer id is controlled with feature flag -->
              @if (canEditCustomerId) {
                @if (canEditCustomerId) {
                  <div class="mb-3 row col-12">
                    <label for="externalId" class="col-sm-3 control-label">{{customerIdLabel}}</label>
                    <div class="col-sm-6">
                      <input [ngClass]="{'is-invalid': isFieldInvalid('externalId')}" id="externalId" class="form-control fs-block" formControlName="externalId" type="text">
                      @if (isFieldInvalid('externalId') && companyForm.get('externalId').hasError('maxlength')) {
                        <span class="invalid-feedback"
                          >
                          Maximum of 100 characters
                        </span>
                      }
                      @if (isFieldInvalid('externalId') && companyForm.get('externalId').hasError('pattern')) {
                        <span class="invalid-feedback"
                          >
                          Customer ID is not valid
                        </span>
                      }
                    </div>
                  </div>
                }
              } @else {
                <div class="mb-3 row col-12">
                  <label class="col-sm-3 control-label">{{customerIdLabel}}</label>
                  <div class="col-sm-6">
                    <p>{{company?.externalId}}</p>
                  </div>
                </div>
              }
              <div class="mb-3 row col-12">
                <label for="address" class="col-sm-3 control-label">Address</label>
                <div class="col-sm-6">
                  <input [ngClass]="{'is-invalid': isFieldInvalid('address')}" id="address" class="form-control fs-block" formControlName="address" type="text">
                  @if (isFieldInvalid('address') && companyForm.get('address').hasError('maxlength')) {
                    <span class="invalid-feedback"
                      >
                      Maximum of 100 characters
                    </span>
                  }
                  @if (isFieldInvalid('address') && companyForm.get('address').hasError('pattern')) {
                    <span class="invalid-feedback"
                      >
                      Address contains incorrect characters
                    </span>
                  }
                </div>
              </div>
              <div class="mb-3 row col-12">
                <label for="country" class="col-sm-3 control-label">Country</label>
                <div class="col-sm-6">
                  <input [ngClass]="{'is-invalid': companyForm.get('country').invalid}" list="country" class="form-control"
                    formControlName="country" placeholder="Enter Country"
                    >
                  <datalist id="country">
                    @for (country of countryCodeArr; track country) {
                      <option [value]="country.code">{{country.name}}</option>
                    }
                  </datalist>
                </div>
              </div>
              <div class="mb-3 row col-12">
                <label for="region" class="col-sm-3 control-label">Region</label>
                <div class="col-sm-6">
                  <input [ngClass]="{'is-invalid': isFieldInvalid('region')}" id="region" class="form-control fs-block" formControlName="region" type="text">
                  @if (isFieldInvalid('region') && companyForm.get('region').hasError('maxlength')) {
                    <span class="invalid-feedback"
                      >
                      Maximum of 75 characters
                    </span>
                  }
                  @if (isFieldInvalid('region') && companyForm.get('region').hasError('pattern')) {
                    <span class="invalid-feedback"
                      >
                      Region contains incorrect characters
                    </span>
                  }
                </div>
              </div>
              @for (customAttrDefinition of customAttrDefinitions; track customAttrDefinition) {
                <div class="mb-3 row col-12">
                  @if (customAttributesValues[customAttrDefinition.key]) {
                    <label for="{{customAttrDefinition.name}}" class="col-sm-3 control-label">{{customAttrDefinition.name}}</label>
                    <div class="col-sm-6">
                      <input type="text"
                        name="{{customAttrDefinition.key}}"
                        class="form-control"
                        value="{{customAttributesValues[customAttrDefinition.key].value}}"
                        (change)="customAttributeChange(customAttrDefinition, $event)" />
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
}
</div>
} @else {
  <borrower-alert [alertText]="accessErrorText"></borrower-alert>
}
